<app-toolbar>
  <div class="right">
    <app-button label="Create Group" icon="mdi mdi-account-multiple-plus" (click)="createGroup()"></app-button>
  </div>
</app-toolbar>
@defer (when groupings()) {
  @if (dataTable) {
    <app-data-table [dataTable]="dataTable" (onRowClick)="showGroup($event)"></app-data-table>
  } @else {
    <app-info-panel>No Groups</app-info-panel>
  }
} @placeholder {
  <app-please-wait></app-please-wait>
}

@switch (dialogOpen()) {
  @case ('update') {
    <app-dialog [header]="userGroup()?.title ?? 'New group'" (onClose)="dialogOpen.set(null)" [dimensions]="{ width: 900, height: 520 }">
      <app-dialog-group [grouping]="userGroup()" (onClose)="groupClosed($event)" />
    </app-dialog>
  }
}
